import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("span", {
    "data-testid": `pickup-detail-status-badge-${_ctx.statusCode.toLowerCase()}`,
    class: ["inline-flex items-center px-2 py-0.5 rounded-full text-14px font-medium", _ctx.statusConfig.className]
  }, _toDisplayString(_ctx.statusConfig.label), 11, ["data-testid"]))
}